import styled from 'styled-components';
import { ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';
import { useEffect, useState } from 'react';
import { userGradeType } from '../../../../utils/auth';
import { LinkSet } from '../../data';
import RegistryModal from '../registryDocument/RegistryModal';
import LimitTable from '../../../components/limit/DetailLimitTable';
import { useUser } from '../../../../context/UserContext';
const attachmentIcon = '/assets/images/icon/Icon_Attachment.svg';

// import NoDataMessage from '../../components/NoData';

interface ListProps {
  etc: string;
  extinctYN: string;
  holder: string;
  lamount: string;
  regDate: string;
  relation: string;
  rno: string;
  rtype: string;
}

interface RegisterStatusProps {
  landInfo: [
    {
      totalAmount: number;
    },
    {
      list: ListProps[];
    },
  ];
  buildingInfo: [
    {
      totalAmount: number;
    },
    {
      list: ListProps[];
    },
  ];
  registerNote: string[];
  anotherInfo: [
    {
      totalAmount: number;
    },
    {
      list: ListProps[];
    },
  ];
  linkSet?: LinkSet;
}

const PRegisterStatus = ({ registerStatus, warning, linkSet }: any) => {
  const { regionAccess, quotaAccess } = useReportContext();
  const { user } = useUser();
  const [openRegistryModal, setOpenRegistryModal] = useState(false);
  const [pdfLink, setPdfLink] = useState<string | null>(null);

  const newData = JSON.parse(registerStatus);
  return (
    <Container id="등기부현황">
      <TitleBox style={{ fontSize: '16px', fontWeight: '700' }}>
        등기부현황
        {linkSet?.buttonLink.buildingRegister?.trim() && (
          <PDFButton
            onClick={() => {
              const isPremium = user?.plan_grade === 'P';
              if (isPremium)
                window.open(linkSet.buttonLink.buildingRegister, '_blank');
              else {
                setPdfLink(linkSet.buttonLink.buildingRegister);
                setOpenRegistryModal(true);
              }
            }}
          >
            <img src="/assets/images/icon/pdf.svg" alt="" />
            건물 등기부 PDF {'>'}
          </PDFButton>
        )}
        {linkSet?.buttonLink.landRegister?.trim() && (
          <PDFButton
            onClick={() => {
              const isPremium = user?.plan_grade === 'P';
              if (isPremium)
                window.open(linkSet.buttonLink.landRegister, '_blank');
              else {
                setPdfLink(linkSet.buttonLink.landRegister);
                setOpenRegistryModal(true);
              }
            }}
          >
            <img src="/assets/images/icon/pdf.svg" alt="" />
            토지 등기부 PDF {'>'}
          </PDFButton>
        )}
        {/* <div style={{ display: 'flex', gap: '4px' }}>
          <AttachButton
            onClick={() => {
              if (linkSet?.buttonLink?.landRegister) {
                window.open(linkSet.buttonLink.landRegister, '_blank');
              }
            }}
          >
            <img src="/assets/images/icon/pdf.svg" alt="" />
            건물등기 {'>'}
          </AttachButton>
          <AttachButton
            onClick={() => {
              if (linkSet?.buttonLink?.buildingRegister) {
                window.open(linkSet.buttonLink.buildingRegister, '_blank');
              }
            }}
          >
            <img src="/assets/images/icon/pdf.svg" alt="" />
            토지등기 {'>'}
          </AttachButton>
        </div> */}
      </TitleBox>
      {!quotaAccess || !regionAccess ? (
        <LimitTable title="등기부현황은" />
      ) : (
        <Content>
          <DataWrapper>
            <table style={{ borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <TableHeadTh width={'25%'}>
                    번호/
                    <br />
                    설정일자
                  </TableHeadTh>
                  <TableHeadTh width={'25%'}>
                    권리종류/<br></br>권리자명
                  </TableHeadTh>
                  <TableHeadTh width={'25%'}>설정금액(원)</TableHeadTh>
                  <TableHeadTh width={'25%'}>비고</TableHeadTh>
                </tr>
              </thead>
              <tbody style={{ width: '100%' }}>
                {newData.slice(1).map((data: any, index: number) => (
                  <TableRowWrapper text={data[1]} key={index}>
                    <TablebodyTd width={'25%'}>
                      {data[0]}/<br></br>
                      {data[3]}
                    </TablebodyTd>
                    <TablebodyTd width={'25%'}>
                      {data[1]}/
                      <br />
                      {data[2]}
                    </TablebodyTd>
                    <TablebodyTd
                      width={'25%'}
                      style={{
                        color:
                          data[1] && data[1].includes('청구금액')
                            ? '#008AFF'
                            : '#171e26',
                        fontWeight:
                          data[1] && data[1].includes('청구금액') ? 700 : 500,
                      }}
                    >
                      {data[4]}
                    </TablebodyTd>
                    <TablebodyTd width={'25%'}>-</TablebodyTd>
                  </TableRowWrapper>
                ))}
                {newData.length === 0 && Nodata()}
              </tbody>
            </table>
          </DataWrapper>
        </Content>
      )}
      {quotaAccess &&
        regionAccess &&
        newData &&
        newData.length > 1 &&
        newData[1] && (
          <YellowBox>
            <img src="/assets/images/icon/warning.svg" alt="" />
            <div>
              본 정보는 공사에 공매의뢰된 시점의 정보로 현행 등기사항증명서과
              다를 수 있으며, 일부 정보의 표시가 누락, 오기될 수 있습니다. 또한,
              아래 순번은 등기사항증명서 순위번호와 무관하며, 이해관계자별 2개
              이상의 권리내용이 있는 경우 편의상 그 내용을 하나의 권리로 표시한
              경우도 있습니다. 따라서 본 정보는 참고용 자료로만 활용하시고
              정확한 정보 확인을 위해서는 반드시 등기사항증명서 관련 공부를
              확인하시기 바랍니다.
            </div>
          </YellowBox>
        )}
      {openRegistryModal && pdfLink && (
        <RegistryModal
          link={pdfLink}
          type={'G'}
          onClose={() => setOpenRegistryModal(false)}
        />
      )}
    </Container>
  );
};

export default PRegisterStatus;

export const RegisterStatus = ({
  landInfo,
  buildingInfo,
  registerNote,
  anotherInfo,
  linkSet,
}: RegisterStatusProps) => {
  const { itemType, regionAccess, quotaAccess } = useReportContext();
  const [showAll, setShowAll] = useState({
    land: false,
    building: false,
    another: false,
  });
  const { user } = useUser();
  const [openRegistryModal, setOpenRegistryModal] = useState(false);
  const [pdfLink, setPdfLink] = useState<string | null>(null);

  const toggleShowAll = (key: 'land' | 'building' | 'another') => {
    setShowAll((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  /** 등기부 데이터 유효성 검사*/
  const isValidData = (data: string): boolean => {
    return /^\((갑|을)\d+\)$/.test(data);
  };

  const convertData = (data: any) => {
    if (data && typeof data === 'string' && data.includes('청구금액')) {
      let temp = data.split(':');
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {temp[0]}:
          <span style={{ color: '#008AFF', fontWeight: 700 }}>{temp[1]}</span>
        </div>
      );
    } else {
      return data || '';
    }
  };

  const handleScroll = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 120;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  return (
    <Container id="등기부현황">
      <Title>
        <span>등기부 현황</span>
        <ButtonWrapper>
          {linkSet?.buttonLink.buildingRegister?.trim() && (
            <PDFButton
              onClick={() => {
                const isPremium = user?.plan_grade === 'P';
                if (isPremium)
                  window.open(linkSet.buttonLink.buildingRegister, '_blank');
                else {
                  setPdfLink(linkSet.buttonLink.buildingRegister);
                  setOpenRegistryModal(true);
                }
              }}
            >
              <img src="/assets/images/icon/pdf.svg" alt="" />
              건물 등기부 PDF {'>'}
            </PDFButton>
          )}
          {linkSet?.buttonLink.landRegister?.trim() && (
            <PDFButton
              onClick={() => {
                const isPremium = user?.plan_grade === 'P';
                if (isPremium)
                  window.open(linkSet.buttonLink.landRegister, '_blank');
                else {
                  setPdfLink(linkSet.buttonLink.landRegister);
                  setOpenRegistryModal(true);
                }
              }}
            >
              <img src="/assets/images/icon/pdf.svg" alt="" />
              토지 등기부 PDF {'>'}
            </PDFButton>
          )}

          {/* <PDFButton
            onClick={() => {
              setOpenRegistryModal(true);
            }}
            $disable={!regionAccess}
          >
            ssssss
          </PDFButton> */}
        </ButtonWrapper>
      </Title>

      {!quotaAccess || !regionAccess ? (
        <ContentItem>
          <ContentItemTitle>
            <img src="/assets/images/icon/icon_registerStatus.svg" alt="" />
            등기부
          </ContentItemTitle>
          <LimitTable title="등기부현황은" />
        </ContentItem>
      ) : (
        <>
          <Content>
            {landInfo &&
            landInfo[1] &&
            landInfo[1].list &&
            landInfo[1].list.length > 0 ? (
              <ContentItem>
                <ContentItemTitle>
                  <img
                    src="/assets/images/icon/icon_registerStatus.svg"
                    alt=""
                  />
                  토지 등기부
                </ContentItemTitle>
                <SingleData>
                  <SingleDataTitle>채권액합계</SingleDataTitle>
                  <SingleDataContent>
                    {' '}
                    {landInfo[0].totalAmount && landInfo[1].list.length > 0
                      ? ReportFormatNumber(landInfo[0].totalAmount)
                      : '해당내용없음'}
                  </SingleDataContent>
                </SingleData>

                <div style={{ borderTop: '1px solid #E5E8EA' }}>
                  <TableContentWrapper>
                    <table
                      style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        borderSpacing: '0',
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            borderSpacing: '0',
                          }}
                        >
                          <TableHeadTh width={'23%'}>
                            {' '}
                            구분/<br></br>접수일
                          </TableHeadTh>
                          <TableHeadTh width={'23%'}>
                            권리종류/
                            <br />
                            권리자/
                            <br />
                            소멸여부
                          </TableHeadTh>
                          <TableHeadTh width={'27%'}>채권금액</TableHeadTh>
                          <TableHeadTh width={'27%'}>비고</TableHeadTh>
                        </tr>
                      </thead>
                      <tbody>
                        {landInfo[1].list.length > 0
                          ? landInfo[1].list
                              .slice(
                                0,
                                showAll.land ? landInfo[1].list.length : 3,
                              )
                              .map(
                                (data, index) =>
                                  isValidData(data.relation) && (
                                    <TableRowWrapper
                                      text={data.etc}
                                      key={index}
                                    >
                                      <TablebodyTd width={'23%'}>
                                        {index + 1}
                                        {isValidData(data.relation)
                                          ? data.relation
                                          : ''}
                                        <br />
                                        {data.regDate}
                                      </TablebodyTd>
                                      <TablebodyTd width={'23%'}>
                                        {data.rtype}
                                        <br></br>
                                        {data.holder}
                                        <br></br>
                                        {data.extinctYN &&
                                          `(${data.extinctYN})`}
                                      </TablebodyTd>
                                      <TablebodyTd
                                        width="27%"
                                        style={{ textAlign: 'left' }}
                                      >
                                        {convertData(data.lamount)}
                                      </TablebodyTd>{' '}
                                      <TablebodyTd width="27%">
                                        {data.etc
                                          ? data.etc
                                              .replace(
                                                '존속기간:',
                                                '존속기간:\n',
                                              )
                                              .replace('~', '~\n')
                                          : ''}
                                      </TablebodyTd>
                                    </TableRowWrapper>
                                  ),
                              )
                          : Nodata()}
                      </tbody>
                    </table>
                    {landInfo[1].list.length > 3 && (
                      <MoreButton
                        onClick={() => {
                          if (showAll.land) {
                            handleScroll('등기부현황');
                          }
                          toggleShowAll('land');
                        }}
                      >
                        <div>{showAll.land ? '접기' : '더보기'}</div>
                        <img
                          style={{
                            transform: showAll.land
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                          }}
                          src="/assets/images/arrow/Arrow_down.png"
                          alt=""
                          width={14}
                          height={14}
                        />
                      </MoreButton>
                    )}
                  </TableContentWrapper>
                </div>
              </ContentItem>
            ) : (
              ''
            )}
            {/* 건물 일때만  나옴  */}
            {itemType === 'H' &&
            buildingInfo &&
            buildingInfo[1] &&
            buildingInfo[1].list &&
            buildingInfo[1].list.length > 0 ? (
              <ContentItem>
                <ContentItemTitle>
                  <img
                    src="/assets/images/icon/icon_registerStatus.svg"
                    alt=""
                  />
                  건물등기부
                </ContentItemTitle>
                <SingleData>
                  <SingleDataTitle>채권액합계</SingleDataTitle>
                  <SingleDataContent>
                    {ReportFormatNumber(buildingInfo[0].totalAmount)}
                  </SingleDataContent>
                </SingleData>
                <div style={{ borderTop: '1px solid #E5E8EA' }}>
                  <TableContentWrapper>
                    <table
                      style={{ borderCollapse: 'collapse', width: '100%' }}
                    >
                      <thead>
                        <tr>
                          <TableHeadTh width={'23%'}>
                            {' '}
                            구분/<br></br>접수일
                          </TableHeadTh>
                          <TableHeadTh width={'23%'}>
                            권리종류/
                            <br />
                            권리자/
                            <br />
                            소멸여부
                          </TableHeadTh>
                          <TableHeadTh width={'27%'}>채권금액</TableHeadTh>
                          <TableHeadTh width={'27%'}>비고</TableHeadTh>
                        </tr>
                      </thead>
                      <tbody>
                        {buildingInfo[1].list.length > 0
                          ? buildingInfo[1].list
                              .slice(
                                0,
                                showAll.building
                                  ? buildingInfo[1].list.length
                                  : 3,
                              )
                              .map(
                                (data, index) =>
                                  isValidData(data.relation) && (
                                    <TableRowWrapper
                                      text={data.etc}
                                      key={index}
                                    >
                                      <TablebodyTd width={'23%'}>
                                        {index + 1}
                                        {isValidData(data.relation)
                                          ? data.relation
                                          : ''}
                                        <br />
                                        {data.regDate}
                                      </TablebodyTd>
                                      <TablebodyTd width={'23%'}>
                                        {data.rtype}
                                        <br></br>
                                        {data.holder}
                                        <br></br>
                                        {data.extinctYN &&
                                          `(${data.extinctYN})`}
                                      </TablebodyTd>
                                      <TablebodyTd
                                        width="27%"
                                        style={{
                                          wordBreak: 'keep-all',
                                          textAlign: 'left',
                                        }}
                                      >
                                        {convertData(data.lamount)}
                                      </TablebodyTd>{' '}
                                      <TablebodyTd width="27%">
                                        {data.etc
                                          ? data.etc
                                              .replace(
                                                '존속기간:',
                                                '존속기간:\n',
                                              )
                                              .replace('~', '~\n')
                                          : ''}
                                      </TablebodyTd>
                                    </TableRowWrapper>
                                  ),
                              )
                          : Nodata()}
                      </tbody>
                    </table>
                    {buildingInfo[1].list.length > 3 && (
                      <MoreButton
                        onClick={() => {
                          if (showAll.building) {
                            handleScroll('등기부현황');
                          }
                          toggleShowAll('building');
                        }}
                      >
                        <div>{showAll.building ? '접기' : '더보기'}</div>
                        <img
                          style={{
                            transform: showAll.building
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                          }}
                          src="/assets/images/arrow/Arrow_down.png"
                          alt=""
                          width={14}
                          height={14}
                        />
                      </MoreButton>
                    )}
                  </TableContentWrapper>
                </div>
              </ContentItem>
            ) : (
              ''
            )}

            {anotherInfo &&
            anotherInfo[1] &&
            anotherInfo[1].list &&
            anotherInfo[1].list.length > 0 ? (
              <ContentItem>
                <ContentItemTitle>
                  <img src="/assets/images/icon/icon_registerStatus.svg" />
                  등기부
                </ContentItemTitle>
                <SingleData>
                  <SingleDataTitle>채권액합계</SingleDataTitle>
                  <SingleDataContent>
                    {ReportFormatNumber(anotherInfo[0].totalAmount)}
                  </SingleDataContent>
                </SingleData>
                <div style={{ borderTop: '1px solid #E5E8EA' }}>
                  <TableContentWrapper>
                    <table
                      style={{ borderCollapse: 'collapse', width: '100%' }}
                    >
                      <thead>
                        <tr>
                          <TableHeadTh width={'23%'}>
                            {' '}
                            구분/<br></br>접수일
                          </TableHeadTh>
                          <TableHeadTh width={'23%'}>
                            권리종류/
                            <br />
                            권리자/
                            <br />
                            소멸여부
                          </TableHeadTh>
                          <TableHeadTh width={'27%'}>채권금액</TableHeadTh>
                          <TableHeadTh width={'27%'}>비고</TableHeadTh>
                        </tr>
                      </thead>
                      <tbody>
                        {anotherInfo[1].list.length > 1 &&
                          anotherInfo[1].list
                            .slice(
                              0,
                              showAll.another ? anotherInfo[1].list.length : 3,
                            )
                            .map(
                              (data, index) =>
                                isValidData(data.relation) && (
                                  <TableRowWrapper text={data.etc} key={index}>
                                    <TablebodyTd width={'23%'}>
                                      {index + 1}
                                      {isValidData(data.relation)
                                        ? data.relation
                                        : ''}
                                      <br />
                                      {data.regDate}
                                    </TablebodyTd>
                                    <TablebodyTd width={'23%'}>
                                      {data.rtype}
                                      <br></br>
                                      {data.holder}
                                      <br></br>
                                      {data.extinctYN && `(${data.extinctYN})`}
                                    </TablebodyTd>
                                    <TablebodyTd
                                      width="27%"
                                      style={{ textAlign: 'left' }}
                                    >
                                      {convertData(data.lamount)}
                                    </TablebodyTd>{' '}
                                    <TablebodyTd width="27%">
                                      {data.etc
                                        ? data.etc
                                            .replace('존속기간:', '존속기간:\n')
                                            .replace('~', '~\n')
                                        : ''}
                                    </TablebodyTd>
                                  </TableRowWrapper>
                                ),
                            )}
                        {anotherInfo[1].list.length === 0 && Nodata()}
                      </tbody>
                    </table>
                    {anotherInfo[1].list.length > 3 && (
                      <MoreButton
                        onClick={() => {
                          if (showAll.another) {
                            handleScroll('등기부현황');
                          }
                          toggleShowAll('another');
                        }}
                      >
                        <div>{showAll.another ? '접기' : '더보기'}</div>
                        <img
                          style={{
                            transform: showAll.another
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                          }}
                          src="/assets/images/arrow/Arrow_down.png"
                          alt=""
                          width={14}
                          height={14}
                        />
                      </MoreButton>
                    )}
                  </TableContentWrapper>
                </div>
              </ContentItem>
            ) : (
              ''
            )}
          </Content>
          {/* {itemType === 'H' && registerNote.length > 1 && (
            <YellowBox>
              <img src="/assets/images/icon/warning.svg" alt="" />
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
              >
                <div style={{ fontWeight: 700, fontSize: 18 }}>주의사항</div>
                {registerNote.map((item, index) => (
                  <div key={index}>{item === '' ? '-' : String(item)}</div>
                ))}
              </div>
            </YellowBox>
          )} */}
        </>
      )}
      {openRegistryModal && pdfLink && (
        <RegistryModal
          link={pdfLink}
          type={'G'}
          onClose={() => setOpenRegistryModal(false)}
        />
      )}
    </Container>
  );
};

function Nodata() {
  return (
    <TableRowWrapper text="">
      <TablebodyTd width="100%" colSpan={4}>
        해당내용없음
      </TablebodyTd>
    </TableRowWrapper>
  );
}

const DataWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #e5e8ea;
`;

interface WidthProps {
  width: string;
}

interface TableRowWrapperProps {
  text: string;
}

const TableContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  align-items: center;
`;

const MoreButton = styled.button`
  width: fit-content;
  padding: 8px 20px;
  background-color: #f7f7f9;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  color: #616161;

  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: center;
  align-items: center;
`;

const TableRowWrapper = styled.tr<TableRowWrapperProps>`
  background-color: ${({ text }) =>
    text && text.includes('말소기준등기') ? '#FFF1F0' : 'none'};

  td,
  th {
    color: ${({ text }) =>
      text && text.includes('말소기준등기') ? '#FA4032' : '#171e26'};
    font-weight: ${({ text }) =>
      text && text.includes('말소기준등기') ? '700' : '500'};
  }

  border-bottom: 1px solid #e1e2e4;
  // &:last-child {
  //   border-bottom: none;
  // }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: white;
  padding: 24px 16px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  font-size: 16px;
  font-weight: 700;
  line-height: 145%; /* 31.9px */
  letter-spacing: -0.32px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PDFButton = styled.div<{ $disable?: boolean }>`
  display: flex;
  padding: 5px 10px 5px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: rgba(2, 32, 71, 0.05);

  cursor: ${({ $disable }) => ($disable ? 'default' : 'pointer')};
  opacity: ${({ $disable }) => ($disable ? 0.2 : 1)};

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  color: #000c1ecc;

  &:hover {
    background-color: ${({ $disable }) => !$disable && '#001b371a'};
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentItemTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.2px;
  letter-spacing: -0.36px;
  color: #222222;
  display: flex;
  gap: 4px;
  align-items: center;
`;
const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 4px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;

  border-right: 1px solid #e8e9ea; /* 기본적으로 border-right 적용 */

  &:nth-last-of-type(1) {
    border-right: none; /* 마지막 요소일 경우 border-right 제거 */
  }
`;
const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px; /* 23.2px */
  letter-spacing: -0.32px;
  color: #171e26;
  word-break: break-word;

  border-right: 1px solid #e8e9ea;
  &:last-child {
    border-right: none;
  }
`;

const SingleRowTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;
const TableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const SingleRowTableHeadCell = styled.div<WidthProps>`
  width: 100%;
  text-align: center;
  border-top: 1px solid #222;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SingleRowTableBodyCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-bottom: 1px solid #e1e2e4;
  padding: 6px 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;
`;
const YellowBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(250, 177, 47, 0.1);
  border-radius: 8px;
  padding: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #a86c00;
`;

const AttachButton = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  padding-top: 5px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 8px;
  gap: 4px;
  background-color: #0220470d;
  align-items: center;

  font-weight: 500;
  font-size: 12px;
  color: #000c1ecc;
`;

const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AttachBox = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
`;

const SingleData = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 8px;
  padding: 10px 16px;
  background-color: #f7f8fc;
`;
const SingleDataTitle = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #616161;
`;

const SingleDataContent = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #222;
`;
